import { render, staticRenderFns } from "./addClassManage.vue?vue&type=template&id=f05f3270"
import script from "./addClassManage.vue?vue&type=script&lang=js"
export * from "./addClassManage.vue?vue&type=script&lang=js"
import style0 from "./addClassManage.vue?vue&type=style&index=0&id=f05f3270&prod&lang=less"
import style1 from "./addClassManage.vue?vue&type=style&index=1&id=f05f3270&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports